import { isWithinInterval } from 'date-fns';

export const minMaxDateValidator = (date: string, minDate: Date, maxDate: Date) => {
  const inputDate = new Date(date).getTime();

  const inRange = isWithinInterval(inputDate, {
    start: minDate,
    end: maxDate,
  });

  return inRange;
};

export const minDateValidator = (date: string, limit: Date | undefined) => {
  if (!limit) return true;
  
  const inputDate = new Date(date).getTime();
  const limitDate = new Date(limit).getTime();

  return inputDate >= limitDate;
};

export const maxDateValidator = (date: string, limit: Date | undefined) => {
  if (!limit) return true;

  const inputDate = new Date(date).getTime();
  const limitDate = new Date(limit).getTime();

  return inputDate <= limitDate;
};
